import { Box, styled } from '@material-ui/core';
import { Skeleton, SkeletonProps } from '@material-ui/lab';
import { distances } from '@setvi/shared/styles';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import { TextColor } from '@setvi/shared/enums';

export const ListContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const ListItem = styled(Box)({
  padding: distances.px.base,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: 8,
  '&:hover': {
    backgroundColor: '#F7F8FA'
  }
});

export const ListItemLoader = styled((props: SkeletonProps) => (
  <Skeleton variant="rect" {...props} />
))({
  width: '100%',
  borderRadius: 8
});

export const CheckIcon = styled(CheckRoundedIcon)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fill: TextColor.Blue
}));
